// Port of api/fuel/app/classes/filter/search/games/filters/post/merge.php
import F from 'offline/filter/constants'

export default {
	name: 'post.merge',
	priority: 50,
	post: true,
	require: function(config, filter, data, results) {
		return filter.status && filter.status.merge && results.mapIndex
	},
	run: function(config, filter, data, results) {
		var seen = {}
		var newIndex = []
		for (var i = 0; i < results.index.length; i++) {
			var id = results.index[i]
			var gameId = results.mapIndex[id]
			if (gameId && !seen[gameId]) {
				seen[gameId] = true
				newIndex.push(id)
			}
		}
		results.index = newIndex
		return results
	}
}
